import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "source" ]

  copy() {
    this.copyQR();
  }

  copyQR = async () => {
    try {
      const org_code = document.getElementById("code_to_copy").innerText;
      const name = document.getElementById("name_to_copy").innerText;
      const imgURL = this.sourceTarget.src;
      
      const imageData = await fetch(imgURL);
      const imageBlob = await imageData.blob();
      const imageBase64Data = await this.blobToBase64(imageBlob);
      
      const html = `
        <div style="text-align: center;">
          <img src="${imageBase64Data}" alt="QRコード" style="width: 250px; height: 250px;" />
          <p style="font-size: 18px; font-weight: bold; margin-top: 10px;">${org_code}</p>
          <p style="font-size: 16px; margin-top: 5px;">${name}</p>
        </div>
      `;
      
      const textBlob = new Blob([html], {
        type: 'text/html'
      });
      
      await navigator.clipboard.write([
        new ClipboardItem({
          [textBlob.type]: textBlob
        })
      ]);
     
     
      
    } catch (err) {
      console.error(err.name, err.message);
     
    }
  }

  blobToBase64(blob) {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }

  
}